const ApplicationsModule = {
  data() {
    return {
      jobs: [],
      applications: [],
      bookmarks: [],
      showAll: false,
    };
  },
  components: {
    Adsense,
    Application,
    JobBox,
  },
  computed: {
    open() {
      return this.applications.filter((a) => a.status !== 'closed');
    },
    closed() {
      return this.applications.filter((a) => a.status === 'closed');
    },
    ajids() {
      return this.applications.map((a) => a.job._id);
    },
    favorites() {
      return this.bookmarks.filter((job) => this.ajids.indexOf(job._id) < 0);
    },
    suggestions() {
      return this.jobs.filter((job) => this.ajids.indexOf(job._id) < 0);
    },
    ...Vuex.mapState(['user']),
  },
  created: function () {
    this.$dmtk.applications
      .get()
      .then((data) => {
        this.applications = data.applications;
      })
      .then((data) => {
        return this.$dmtk.jobs.suggestions();
      })
      .then((data) => {
        this.jobs = data.jobs;
        this.bookmarks = data.bookmarks;
        if (this.$route.hash === '#recomendados') {
          setTimeout(
            () => document.getElementById('recomendados').scrollIntoView(),
            300,
          );
        }
      });
  },
  template: `
    <div class="applications uk-margin-large-bottom">

      <Adsense unit="3423209573" />

      <div class="header uk-text-center uk-width-xxlarge uk-margin-medium-top uk-margin-large-bottom">
        <h1 class="uk-text-bold">Inscripciones</h1>
        <p>
          Aquí puedes ver las ofertas a las que te has inscrito y el estado de tu inscripción.
        </p>
      </div>

      <div class="uk-block uk-margin-bottom">

        <h3>Mis Inscripciones</h3>

        <div class="uk-alert uk-alert-primary" v-if="open.length === 0">
          No tienes ninguna inscripción activa.
        </div>

        <div class="application-list" v-if="open.length > 0">
          <div class="application" v-for="application in open" :class="{ ['-'+application.status]: true }">
            <Application :application="application" />
          </div>
        </div>

        <div class="application-list" v-if="closed.length > 0 && showAll">
          <div class="application" v-for="application in closed" :class="{ ['-'+application.status]: true }">
            <Application :application="application" />
          </div>
        </div>

        <p v-if="closed.length > 0 && !showAll">
          Tienes {{ closed.length }}
          {{ closed.length > 1 ? 'inscripciones cerradas' : 'inscripción cerrada' }}.
          <a @click.prevent="showAll = true">Ver todas</a>
        </p>

        <p v-if="open.length + closed.length > 0 && applications[0].profile.type === 'P'">
          <a href="/empleo/inscripciones/pdf/" target="_blank">Descargar certificado de búsqueda de empleo</a>
        </p>

      </div>

      <div id="recomendados" class="uk-block uk-margin-bottom uk-margin-large-top">

        <h3>
          Mis ofertas guardadas
        </h3>
        <div class="job-list" v-if="favorites.length">
          <JobBox :job="job" :bookmarked="true" v-for="job in favorites" :key="job._id" />
        </div>
        <div v-else>
          <div class="uk-alert">
            No tienes ninguna oferta guardada...
          </div>
        </div>
          
        <h3 class="uk-margin-medium-top">
          Otras ofertas que te pueden interesar
        </h3>
        <div class="job-list" v-if="suggestions.length">
          <JobBox :job="job" v-for="job in suggestions" :key="job._id" />
        </div>
        <div v-else>
          <div class="uk-alert clickable" @click="$router.push('/perfil/notificaciones')">
            En este momento no hay ofertas disponibles para las actividades y sitios en los que te has registrado.
            Prueba a añadir más actividades y ampliar tu zona de trabajo para poder acceder a más ofertas en este panel.
          </div>
        </div>
      </div>

      <div class="uk-text-center uk-margin-medium-top uk-margin-medium-bottom">
        <a href="/empleo/localidades/" class="uk-button uk-button-dmtk -twolines">
          Ver todas las ofertas de empleo
        </a>
      </div>

    </div>
  `,
};
